
import React, { useState, useEffect } from 'react'
import { Row, Card, Col } from 'react-bootstrap'
import { ceil, range } from 'lodash';
import { Pagination } from 'react-bootstrap'

function PagingSmall(props) {

  const [endPage, setEndPage] = useState(props.data.sizePage)
  const [activePage, setActivePage] = useState(1)
  const [sizePage, setSizePage] = useState(props.data.sizePage)

  var pageNumber = ceil(props.data.totalItems / sizePage)
  var listPageNumber = range(1, pageNumber + 1)

  useEffect(() => {
    const data = {
      start: 0,
      end: props.data.sizePage
    }
    props.callBack(data)

  }, [])





  const handlePagination = (end) => {
    setActivePage(end)
    setEndPage(end * sizePage)
    const data = {
      start: (end * sizePage) - sizePage,
      end: (end * sizePage)
    }
    props.callBack(data)

  }

  const handlePrevPagination = () => {
    handlePagination(endPage / sizePage - 1)
  }
  const handleNextPagination = () => {
    handlePagination(endPage / sizePage + 1)
  }



  return (
    <>
      {pageNumber > 1 &&
        <Row className='d-flex justify-content-center mt-5'>
          <Pagination>

            <Pagination.Prev onClick={handleNextPagination} disabled={!(activePage < pageNumber)} />
            {listPageNumber.reverse().map((item, index) => <Pagination.Item key={index} onClick={() => handlePagination(item)} active={activePage === item} >{item}</Pagination.Item>)}

            <Pagination.Next onClick={handlePrevPagination} disabled={!(activePage > 1)} />

          </Pagination>
        </Row>
      }
    </>
  )
}

export default PagingSmall